const getRestaurantOrder = (order, restaurantId) =>
  order?.restaurantOrders?.find(
    (restaurantOrder) => restaurantOrder.restaurantId === restaurantId
  );

export default getRestaurantOrder;
